import { useEffect } from 'react';

import { VisierAnalytics } from 'Deer/components/Visier/VisierAnalytics';
import { getApplicableL2MyTeamModules } from 'Deer/components/navigation/secondary/MyTeam/MyTeamModules';
import { useDeerTeamType } from 'Deer/hooks/useDeerTeamType';
import { useRouteToMyTeamLevels } from 'Deer/hooks/useRouteToL3';
import { IntentDropdown } from 'Deer/intent/Goals/components/IntentDropdown';
import { Layout } from 'Deer/intent/components/Layout/Layout';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import Header from 'screens/Team/Rabbit/Goals/Header';
import { checkIntentLandingPagesFeatureEnabled } from 'utils/helpers/featureFlags';

import { TEAM_SKIP_VISIER_ANALYSIS } from 'constants/ProjectConstants';
import { modifyString, StringModifier } from 'constants/copyHelpers';
import { sendPageViewEvent } from 'constants/mixpanelHelper';

import { PageTabbedNavigationV1 } from 'uiToolkitV1/PageTabbedNavigationV1';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headerLabel: string;
}
const AllReportGoalsEmbeddedAnalytics = ({ headerLabel }: Props) => {
  const { l3Options: tabs } = useRouteToMyTeamLevels();
  const { moduleName } = useOrganisationSettings();
  const modifiedHeaderLabel = `${headerLabel} ${modifyString(moduleName, StringModifier.PLURAL_SENTENCE_CASE)}`;
  const applicableL2DirectReportsModules = getApplicableL2MyTeamModules('directReports', moduleName);
  const applicableL2AllReportsModules = getApplicableL2MyTeamModules('allReports', moduleName);
  const teamType = useDeerTeamType();

  useEffect(() => {
    sendPageViewEvent({
      eventProperties: {
        page: 'Skip Team-goals-visier insights',
      },
    });
  }, []);

  if (checkIntentLandingPagesFeatureEnabled()) {
    return (
      <Layout
        Filters={
          <IntentDropdown
            showKebabMenu={false}
            breadcrumbs={{
              items: [
                {
                  label: teamType === 'allReports' ? 'Skip Team' : 'Direct Team',
                  to:
                    teamType === 'allReports'
                      ? applicableL2AllReportsModules[0]?.value
                      : applicableL2DirectReportsModules[0]?.value,
                },
              ],
              page: {
                label: modifyString(moduleName, StringModifier.PLURAL_TITLE_CASE),
                to: '',
              },
            }}
          />
        }
      >
        <VisierAnalytics id={TEAM_SKIP_VISIER_ANALYSIS[0].id} />
      </Layout>
    );
  }

  return (
    <>
      <Header teamName={modifiedHeaderLabel} />
      <PageTabbedNavigationV1 tabs={tabs} />
      <VisierAnalytics id={TEAM_SKIP_VISIER_ANALYSIS[0].id} />
    </>
  );
};

export { AllReportGoalsEmbeddedAnalytics };
